import { useEffect, useState } from 'react';
import { useEventListener, useGallery, usePage } from 'app/hooks';
import { useGalleryService } from 'app/hooks/useGalleryService';
import { useSearchPathBuilder } from '@unisporkal/search-url-builder';
import { clearCache as clearLegacyGalleryServiceCache } from 'app/services/galleryService';
import useSearchParametersAdapter from 'app/adapters/shared/searchParameters/useSearchParametersAdapter';
import useSearchQueryAdapter from 'app/adapters/shared/searchParameters/useSearchQueryAdapter';

export default () => {
  const PREFETCH_PERCENTAGE = 0.6;

  const [prefetched, setPrefetched] = useState(false);
  const gallery = useGallery();
  const page = usePage();
  const toSearchQuery = useSearchQueryAdapter();
  const galleryService = useGalleryService();
  const searchPathBuilder = useSearchPathBuilder();
  const pageDocument = typeof document !== 'undefined' ? document : null;
  const searchParameters = useSearchParametersAdapter();

  const shouldPrefetch = () =>
    !prefetched &&
    (window.scrollY + window.innerHeight) /
      pageDocument.body.getBoundingClientRect().height >
      PREFETCH_PERCENTAGE;

  const handleScroll = () => {
    if (shouldPrefetch()) {
      // TODO: This whole file has an unavoidable dependency cycle, where there is not scenario where we can avoid the `no-use-before-define` rule.
      // eslint-disable-next-line no-use-before-define
      prefetch();
    }
  };

  const [enableScroll, disableScroll] = useEventListener(
    'scroll',
    handleScroll,
    pageDocument,
    true
  );

  async function prefetch() {
    disableScroll();
    setPrefetched(true);

    const queryParams = toSearchQuery(
      searchParameters.with({
        page: gallery.pageNumber() + 1,
      })
    );
    const path = searchPathBuilder.searchPath(queryParams);
    galleryService.getSearch(path);
  }

  useEffect(() => {
    if (page.isInitializedOrLoaded()) {
      setPrefetched(false);
      enableScroll();
      galleryService.clearCache();

      // Redux search still uses the module-level legacy GalleryService singleton
      // (see galleryService getLegacyService). Clear it too so prefetch hits and
      // gallery actions do not read stale JSON for a different URL than the live page.
      clearLegacyGalleryServiceCache();
    }
  }, [page.status]);
};
